import { whiteAlfa as e, red as t, purple as r, orange as i, green as o, graphiteAlfa as a, graphite as l, blue as g, black as n } from "./index3.mjs";
import { breakpoint as p, rounded as h, size as c } from "./index4.mjs";
import { display as d, heading as m, body as f, label as b } from "./index5.mjs";
import { overlay as u, gradient as L, brandLight as s, interactLight as y, outlineLight as x, icotextLight as k, surfaceLight as A } from "./index11.mjs";
const j = {
  color: {
    ...n,
    ...g,
    ...l,
    ...a,
    ...o,
    ...i,
    ...r,
    ...t,
    ...e
  },
  palette: {
    surface: A,
    icotext: k,
    outline: x,
    interact: y,
    brand: s,
    gradient: L,
    overlay: u
  },
  size: c,
  rounded: h,
  breakpoint: p,
  label: b,
  body: f,
  heading: m,
  display: d
};
export {
  j as gloryLightTheme
};
